var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "formula-field-editor" },
    [
      _c("div", { staticClass: "editor-container" }, [
        _c("div", { staticClass: "toolbar" }, [
          _c(
            "div",
            { staticClass: "insert-field" },
            [
              _c(
                "a-dropdown",
                { attrs: { trigger: ["click"] } },
                [
                  _c("a-button", [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("table_view"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("table.addFields")) + " "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    _vm._l(_vm.availableFields, function (field) {
                      return _c(
                        "a-menu-item",
                        {
                          key: field._id,
                          on: {
                            click: function ($event) {
                              return _vm.insertField(field)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v(_vm._s(_vm.getFieldIcon(field.fieldType))),
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(field.name) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "insert-function" },
            [
              _c(
                "a-dropdown",
                { attrs: { trigger: ["click"] } },
                [
                  _c("a-button", [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("functions"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("table.addFunctions")) + " "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-menu",
                    {
                      staticClass: "function-menu",
                      attrs: { slot: "overlay" },
                      slot: "overlay",
                    },
                    _vm._l(_vm.functionCategories, function (category) {
                      return _c(
                        "a-sub-menu",
                        { key: category.key, attrs: { title: category.label } },
                        _vm._l(category.functions, function (func) {
                          return _c(
                            "a-menu-item",
                            {
                              key: func.name,
                              on: {
                                click: function ($event) {
                                  return _vm.insertFunction(func)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "function-item" }, [
                                _c("span", { staticClass: "function-name" }, [
                                  _vm._v(_vm._s(func.name)),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "function-desc" }, [
                                  _vm._v(_vm._s(func.description)),
                                ]),
                              ]),
                            ]
                          )
                        }),
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ai-assistant" },
            [
              _c(
                "SupsisButton",
                {
                  staticClass: "ai-suggest-button",
                  attrs: { ghost: "" },
                  on: { click: _vm.showAiAssistant },
                },
                [
                  _c("img", {
                    staticClass: "copilot-icon",
                    attrs: { src: "/static/img/copilot.png" },
                  }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("table.createFormulaWithAssistant")) +
                      "\n                "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "editor" }, [
          _c(
            "div",
            {
              ref: "editorContainer",
              staticClass: "formula-input-container",
              on: { keydown: _vm.handleKeyDown, click: _vm.setFocus },
            },
            [
              _c("div", {
                ref: "editorInput",
                staticClass: "formula-input",
                attrs: { contenteditable: "true", spellcheck: "false" },
                on: {
                  input: _vm.handleEditorInput,
                  keyup: _vm.handleKeyUp,
                  blur: _vm.handleBlur,
                  paste: _vm.handlePaste,
                },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.showAutocomplete
            ? _c(
                "div",
                {
                  staticClass: "autocomplete-dropdown",
                  style: _vm.autocompletePosition,
                },
                [
                  _c("div", { staticClass: "autocomplete-title" }, [
                    _vm._v(_vm._s(_vm.autocompleteTitle)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "autocomplete-items" },
                    _vm._l(_vm.autocompleteItems, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "autocomplete-item",
                          class: {
                            active: _vm.autocompleteSelectedIndex === index,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.insertAutocompleteItem(item)
                            },
                          },
                        },
                        [
                          _vm.autocompleteType === "function"
                            ? [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("functions"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "autocomplete-item-details" },
                                  [
                                    _c("div", { staticClass: "item-name" }, [
                                      _vm._v(_vm._s(item.name)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "item-description" },
                                      [_vm._v(_vm._s(item.description))]
                                    ),
                                    _vm._v(" "),
                                    item.syntax
                                      ? _c(
                                          "div",
                                          { staticClass: "item-syntax" },
                                          [_vm._v(_vm._s(item.syntax))]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            : _vm.autocompleteType === "field"
                            ? [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v(
                                    _vm._s(_vm.getFieldIcon(item.fieldType))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "autocomplete-item-details" },
                                  [
                                    _c("div", { staticClass: "item-name" }, [
                                      _vm._v(_vm._s(item.name)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "item-description" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getFieldTypeLabel(
                                              item.fieldType
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "syntax-help" }, [
          _vm.error
            ? _c("p", { staticClass: "error-message" }, [
                _vm._v(_vm._s(_vm.error)),
              ])
            : _vm.expression
            ? _c("p", { staticClass: "preview-message" }, [
                _c("span", { staticClass: "preview-label" }, [
                  _vm._v("Önizleme:"),
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "highlighted-expression",
                  domProps: {
                    innerHTML: _vm._s(_vm.escapedHighlightedExpression),
                  },
                }),
              ])
            : _c("p", { staticClass: "help-message" }, [
                _vm._v(
                  "\n                Formül oluşturmak için alan ve fonksiyonları ekleyin. Formüller, değerleri diğer alanlardan hesaplar\n                ve otomatik olarak güncellenir.\n            "
                ),
              ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "examples-section" },
        [
          _c(
            "a-collapse",
            [
              _c(
                "a-collapse-panel",
                { key: "1", attrs: { header: "Formül Örnekleri" } },
                [
                  _c(
                    "div",
                    { staticClass: "examples" },
                    _vm._l(_vm.formulaExamples, function (example, index) {
                      return _c("div", { key: index, staticClass: "example" }, [
                        _c(
                          "div",
                          { staticClass: "example-header" },
                          [
                            _c("span", { staticClass: "example-name" }, [
                              _vm._v(_vm._s(example.name)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.useExample(example.formula)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("content_copy"),
                                ]),
                                _vm._v(" Kullan\n                            "),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "example-formula",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.renderSafeHTML(
                                _vm.highlightSyntax(example.formula)
                              )
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "example-description" }, [
                          _vm._v(_vm._s(example.description)),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.aiAssistantVisible
        ? _c(
            "Modal2",
            {
              staticClass: "voice-agent-modal",
              attrs: {
                title: "Supsis Asistan: Formül Oluşturucu",
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.aiAssistantVisible = false
                },
              },
            },
            [
              _c("FormulaGenerator", {
                attrs: { tableId: _vm.tableId },
                on: { "formula-generated": _vm.useGeneratedFormula },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }